import 'core-js/modules/es.object.assign.js';
import { __awaiter } from '../../../../_virtual/_tslib.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { Popover, Stack, PopoverItem, Text, Button, Snackbar } from '@hub-la/design-system';
import { MoreHorizOutlined } from '@mui/icons-material';
import DeleteOutlined from '@mui/icons-material/DeleteOutlined';
import EditOutlined from '@mui/icons-material/EditOutlined';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDeleteComment } from '../../hooks/use-delete-comment.js';
import { useDiscussion } from '../../providers/discussion.js';

const CommentOptions = ({
  userId,
  commentId,
  isReply,
  parentCommentId,
  onEdit
}) => {
  const {
    t
  } = useTranslation();
  const {
    isOwnerOfComment
  } = useDiscussion();
  const {
    mutateAsync,
    isSuccess,
    isError,
    reset
  } = useDeleteComment({
    isReply,
    parentCommentId
  });
  const handleDeleteComment = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
    yield mutateAsync({
      commentId
    });
  }), [commentId, mutateAsync]);
  return jsxs(Fragment, {
    children: [jsx(Popover, Object.assign({
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      },
      items: ({
        close
      }) => jsxs(Stack, {
        children: [isOwnerOfComment(userId) && jsxs(PopoverItem, Object.assign({
          onClick: () => {
            close();
            onEdit();
          }
        }, {
          children: [jsx(EditOutlined, {}), jsx(Text, Object.assign({
            ml: 3
          }, {
            children: isReply ? t('comment.options.edit.answer') : t('comment.options.edit.unique')
          }))]
        })), jsxs(PopoverItem, Object.assign({
          onClick: () => {
            close();
            handleDeleteComment();
          }
        }, {
          children: [jsx(DeleteOutlined, {}), jsx(Text, Object.assign({
            ml: 3
          }, {
            children: isReply ? t('comment.options.delete.answer') : t('comment.options.delete.unique')
          }))]
        }))]
      })
    }, {
      children: jsx(Button, Object.assign({
        iconOnly: true,
        variant: "text",
        size: "small",
        hierarchy: "secondary"
      }, {
        children: jsx(MoreHorizOutlined, {})
      }))
    })), isSuccess && jsx(Snackbar, Object.assign({
      open: isSuccess,
      variant: "positive",
      autoHideDuration: 6000,
      onClose: reset
    }, {
      children: t('comment.snackbarFeedback.delete.success')
    })), isError && jsx(Snackbar, Object.assign({
      open: isError,
      variant: "negative",
      autoHideDuration: null,
      onClose: reset
    }, {
      children: t('comment.snackbarFeedback.delete.error')
    }))]
  });
};

export { CommentOptions };
